import React, {useState} from 'react';
import './ImageGallery.scss';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import classNames from 'classnames';

export type ImageGalleryProps = {
    imageIds: number[];
    imageSize?: number;
    getThumbnailUrl: (imageId: number) => string;
    getImageUrl: (imageId: number) => string;
    className?: string;
};

export const ImageGallery: React.FC<ImageGalleryProps> = ({imageIds, getThumbnailUrl, imageSize, getImageUrl, className = ''}) => {
    const [imageIndex, setImageIndex] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<boolean>(false);

    if (!Array.isArray(imageIds)) {
        imageIds = [];
    }

    const renderPreviews = imageIds.map((fileId, index) => (
        <div className={'thumb'} style={{width: imageSize, height: imageSize}} key={index}>
            <div
                className={'thumbInner'}
                onClick={e => {
                    setIsOpen(true);
                    setImageIndex(index);
                }}
            >
                <img src={getThumbnailUrl(fileId)} width={imageSize} height={imageSize} />
            </div>
        </div>
    ));

    return (
        <div onClick={e => e.stopPropagation()} className={classNames('image-gallery', className)}>
            {isOpen && (
                <Lightbox
                    mainSrc={getImageUrl(imageIds[imageIndex])}
                    nextSrc={getImageUrl(imageIds[(imageIndex + 1) % imageIds.length])}
                    prevSrc={getImageUrl(imageIds[(imageIndex + imageIds.length - 1) % imageIds.length])}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() => setImageIndex((imageIndex + imageIds.length - 1) % imageIds.length)}
                    onMoveNextRequest={() => setImageIndex((imageIndex + 1) % imageIds.length)}
                    reactModalStyle={{overlay: {zIndex: 42000}}}
                />
            )}
            <section className={'thumbsContainer'}>{renderPreviews}</section>
        </div>
    );
};
